import axios from "axios";

const SUBSCRIBE_URL =
  "https://apissl.playit.mobi/api/v3/Unitel/portal/subscribe";

export async function getPhoneByHeader(linkheader = "./checkheaderunitel.php") {
  try {
    const res = await axios.get(linkheader);
    if (res.data && res.data !== "") {
      return res.data;
    }
    return null;
  } catch (err) {
    console.error("Unitel header enrich failed:", err);
    return null;
  }
}

export function toApiMsisdn(phone) {
  let digits = String(phone || "").replace(/[^0-9]/g, "");
  if (!digits) {
    return "";
  }

  if (digits.startsWith("0")) {
    digits = digits.replace(/^0+/, "");
  }

  if (!digits.startsWith("244")) {
    digits = `244${digits}`;
  }

  return digits;
}

export async function portalSubscribe(msisdn) {
  const res = await axios.post(
    SUBSCRIBE_URL,
    { msisdn },
    { headers: { "Content-Type": "application/json" } }
  );
  return res.data;
}
